export default __webpack_public_path__ + "static/media/FundoPlanetarioOpaco.bcb78c62.png";